<admin-panel-empty>
  <admin-panel-empty>
    <div class="row">
      <div class="col-4">
        <div class="mb-3">
          <span class="">keys</span>
          <div class="text-dark message-content border" style="border-style: dashed !important;">
            {{ profile?.keys | json}}
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="mb-3">
          <span class="">granularity</span>
          <div class="text-dark message-content border" style="border-style: dashed !important;">
            {{ profile?.granularity | json}}
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="mb-3">
          <span class="">reset</span>
          <div class="text-dark message-content border" style="border-style: dashed !important;">
            {{ profile?.reset | json}}
          </div>
        </div>
      </div>
    </div>
  </admin-panel-empty>

  <admin-panel-standard [title]="'Values'">
    <admin-table-standard [items]="profile?.values!">
      <ng-template #header>
        <th class="col-md-4" scope="col">{{ 'pages.channels.view.fields.name' | translate }}</th>
        <th class="col-md-4" scope="col">{{ 'pages.channels.view.fields.type' | translate }}</th>
        <th class="col-md-4" scope="col">{{ 'pages.channels.view.labels.value' | translate }}</th>
      </ng-template>
      <ng-template #first let-item>
        <td>{{ item.name }}</td>
        <td>{{ item.kind }}</td>
        <td>{{ item.value | json }}</td>
      </ng-template>
    </admin-table-standard>
  </admin-panel-standard>

  <div class="pt-3"></div>

  <admin-panel-standard [title]="'States'">
    <admin-table-collapsable [items]="profile?.states!">
      <ng-template #header>
        <th style="width: 22%">name</th>
        <th style="width: 22%">labels</th>
        <th style="width: 22%">period</th>
        <th style="width: 22%">duration</th>
        <th style="width: 12%">&nbsp;</th>
      </ng-template>
      <ng-template #first let-item let-index="index" let-refid="refid">
        <td>{{item.name}}</td>
        <td>{{item.labels  | json }}</td>
        <td>{{item.period  | json }}</td>
        <td>{{item.duration | json }}</td>
        <td class="justify-content-around text-end weight-label">
          <a (click)="viewState(item)" class="text-decoration-none action-buttons" data-bs-toggle="collapse" [attr.data-bs-target]="'#item' + refid + index" href="#">
            <i class="bi bi-info-square"></i>&nbsp;aggregates
          </a>
        </td>
      </ng-template>
      <ng-template #second let-item>
        <admin-panel-inner>
          <admin-table-standard [items]="state.aggregates" [custom]="['inner-table']">
            <ng-template #header>
              <th style="width: 20%">name</th>
              <th style="width: 20%">operation</th>
              <th style="width: 20%">values</th>
              <th style="width: 20%">key</th>
              <th style="width: 20%">groupby</th>
            </ng-template>
            <ng-template #first let-item>
              <td>{{item.name}}</td>
              <td>{{item.operation | json }}</td>
              <td>{{item.values | json }}</td>
              <td>{{item.key | jsonOrEmpty }}</td>
              <td>{{item.groupby | jsonOrEmpty }}</td>
            </ng-template>
          </admin-table-standard>
        </admin-panel-inner>
      </ng-template>
    </admin-table-collapsable>
  </admin-panel-standard>
</admin-panel-empty>
